const localization = {
  fr: {
    altText: 'Le logo du canton du Valais',
    titleText: "vers la page d'accueil",
  },
  de: {
    altText: 'Das Logo des Kanton Wallis',
    titleText: 'zur Startseite',
  },
  it: {
    altText: 'Il logo del Canton Vallese',
    titleText: 'alla pagina iniziale',
  },
  en: {
    altText: 'The logo of the canton of Valais',
    titleText: 'to the homepage',
  },
};

export default localization;
